import axios from "axios";

export default {

    // SECTOR //

    getSector(_, params) {
        return axios.post('/api/sector/getsectors', params, { withCredentials: true })
    },
    createSector(_, params) {
        return axios.post('/api/sector/createsector', params, { withCredentials: true })
    },
    updateSector(_, params) {
        return axios.post('/api/sector/updatesector', params, { withCredentials: true })
    },
    deleteSector(_, params) {
        return axios.post('/api/sector/deletesector', params, { withCredentials: true })
    },

    // TOPIC //

    getAllTopics(_, params) {
        return axios.post("/api/topic/getalltopics", params, { withCredentials: true });
    },

    // EXCEL //

    downloadSampleExcel(_, fileName) {
        axios
          .post(
            `/api/download/excel`,
            {
              type: "element",
            },
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
          });
    },

    // CATEGORİES //

    getCategory(_, params) {
        return axios.post('/api/category/getcategories', params, { withCredentials: true })
    },
    createCategory(_, params) {
        return axios.post('/api/category/createcategory', params, { withCredentials: true })
    },
    updateCategory(_, params) {
        return axios.post('/api/category/updatecategory', params, { withCredentials: true })
    },
    deleteCategory(_, params) {
        return axios.post('/api/category/deletecategory', params, { withCredentials: true })
    },

    // TARGET //

    getTarget(_, params) {
        return axios.post('/api/target/gettargets', params, { withCredentials: true })
    },
    createTarget(_, params) {
        return axios.post('/api/target/createtarget', params, { withCredentials: true })
    },
    updateTarget(_, params) {
        return axios.post('/api/target/updatetarget', params, { withCredentials: true })
    },
    deleteTarget(_, params) {
        return axios.post('/api/target/deletetarget', params, { withCredentials: true })
    },

    // TARGET AREA //

    getTargetArea(_, params) {
        return axios.post('/api/targetarea/gettargetareas', params, { withCredentials: true })
    },
    createTargetArea(_, params) {
        return axios.post('/api/targetarea/createtargetarea', params, { withCredentials: true })
    },
    updateTargetArea(_, params) {
        return axios.post('/api/targetarea/updatetargetarea', params, { withCredentials: true })
    },
    deleteTargetArea(_, params) {
        return axios.post('/api/targetarea/deletetargetarea', params, { withCredentials: true })
    },

    // KPI //

    getKPI(_, params) {
        return axios.post('/api/kpi/getkpis', params, { withCredentials: true })
    },
    createKPI(_, params) {
        return axios.post('/api/kpi/createkpi', params, { withCredentials: true })
    },
    updateKPI(_, params) {
        return axios.post('/api/kpi/updatekpi', params, { withCredentials: true })
    },
    deleteKPI(_, params) {
        return axios.post('/api/kpi/deletekpi', params, { withCredentials: true })
    },

    // ELEMENT //

    getElement(_, params) {
        return axios.post('/api/element/getelements', params, { withCredentials: true })
    },
    createElement(_, params) {
        return axios.post('/api/element/createelement', params, { withCredentials: true })
    },
    updateElement(_, params) {
        return axios.post('/api/element/updateelement', params, { withCredentials: true })
    },
    deleteElement(_, params) {
        return axios.post('/api/element/deleteelement', params, { withCredentials: true })
    },

    // Metric KPI //

    getMetric(_, params) {
        return axios.post('/api/metrickpi/getmetrickpis', params, { withCredentials: true })
    },
    createMetric(_, params) {
        return axios.post('/api/metrickpi/createmetrickpi', params, { withCredentials: true })
    },
    updateMetric(_, params) {
        return axios.post('/api/metrickpi/updatemetrickpi', params, { withCredentials: true })
    },
    deleteMetric(_, params) {
        return axios.post('/api/metrickpi/deletemetrickpi', params, { withCredentials: true })
    },

    // Sub Metric KPI //

    getSubMetric(_, params) {
        return axios.post('/api/submetrickpi/getsubmetrickpis', params, { withCredentials: true })
    },
    createSubMetric(_, params) {
        return axios.post('/api/submetrickpi/createsubmetrickpi', params, { withCredentials: true })
    },
    updateSubMetric(_, params) {
        return axios.post('/api/submetrickpi/updatesubmetrickpi', params, { withCredentials: true })
    },
    deleteSubMetric(_, params) {
        return axios.post('/api/submetrickpi/deletesubmetrickpi', params, { withCredentials: true })
    },

    // Global Goals //

    getGlobalGoals() {
        return axios.get('/api/su1option/getglobalgoals', { withCredentials: true })
    },
    createGlobalGoals(_, params) {
        return axios.post('/api/su1option/createglobalgoal', params, { withCredentials: true })
    },
    updateGlobalGoals(_, params) {
        return axios.post('/api/su1option/updateglobalgoal', params, { withCredentials: true })
    },
    deleteGlobalGoals(_, params) {
        return axios.post('/api/su1option/deleteglobalgoal', params, { withCredentials: true })
    },

    // Sub Goals //

    getSubGoals() {
        return axios.get('/api/su1option/getsubgoals', { withCredentials: true })
    },
    createSubGoals(_, params) {
        return axios.post('/api/su1option/createsubgoal', params, { withCredentials: true })
    },
    updateSubGoals(_, params) {
        return axios.post('/api/su1option/updatesubgoal', params, { withCredentials: true })
    },
    deleteSubGoals(_, params) {
        return axios.post('/api/su1option/deletesubgoal', params, { withCredentials: true })
    },

    // Green Deals //

    getGreenDeals() {
        return axios.get('/api/su1option/getgreendeals', { withCredentials: true })
    },
    createGreenDeals(_, params) {
        return axios.post('/api/su1option/creategreendeal', params, { withCredentials: true })
    },
    updateGreenDeals(_, params) {
        return axios.post('/api/su1option/updategreendeal', params, { withCredentials: true })
    },
    deleteGreenDeals(_, params) {
        return axios.post('/api/su1option/deletegreendeal', params, { withCredentials: true })
    },

    // Prompt //

    getPromptsByCompanyId(_, params) {
        return axios.post('/api/prompt/getprompts', params ,{ withCredentials: true })
    },
    createPrompt(_, params) {
        return axios.post('/api/prompt/createprompt', params, { withCredentials: true })
    },
    updatePrompt(_, params) {
        return axios.post(`/api/prompt/updateprompt/${params.prompt_id}`, {
            prompt_text: params.prompt_text,
            updated_by: params.updated_by
        }, { withCredentials: true })
        },
    deletePrompt(_, params) {
        return axios.post('/api/prompt/deleteprompt', params, { withCredentials: true })
    },

    // Element Prompt //
    getElementPrompts(_, params) {
        return axios.post("/api/prompt/getelementprompts", params, { withCredentials: true })
    },
    createElementPrompt(_, params) {
        return axios.post("/api/prompt/createelementprompt", params, { withCredentials: true })
    },
    updateElementPrompt(_, params) {
        return axios.post(`/api/prompt/updateelementprompt/${params.prompt_id}`, {
            element_prompt_text: params.element_prompt_text,
            updated_by: params.updated_by
        }, { withCredentials: true })
        },
    deleteElementPrompt(_, params) {
        return axios.post('/api/prompt/deleteelementprompt', params, { withCredentials: true })
    },

    // Sust Report Prompt //
    getSustPrompts(_, params) {
        return axios.post("/api/prompt/getsustreportprompts", params, { withCredentials: true })
    },
    createSustPrompt(_, params) {
        return axios.post("/api/prompt/createsustreportprompt", params, { withCredentials: true })
    },
    updateSustPrompt(_, params) {
        return axios.post(`/api/prompt/updatesustreportprompt/${params.prompt_id}`, {
            sust_report_prompt_text: params.sust_report_prompt_text,
            updated_by: params.updated_by
        }, { withCredentials: true })
        },
    deleteSustPrompt(_, params) {
        return axios.post('/api/prompt/deletesustreportprompt', params, { withCredentials: true })
    },


    // BULK //

    bulkSustTable(_, params) {
        return axios.post('/api/susttables/bulkregistersust', params, { withCredentials: true })
    },


    // CARBON MODULE //

    getCarbonFactors(_, params) {
        return axios.post(`/api/carbon/getcarbonfactorsadditionalsettings`, params, { withCredentials: true });
    },

    getIndividualCarbonElement(_, params) {
        return axios.post(`/api/carbon/getindividualcarbonelement/${params.carbon_element_id}`, params, { withCredentials: true });
    },

    createCarbonElement(_, params) {
        return axios.post("/api/carbon/createcarbonelement", params, {withCredentials: true});
    },

    updateCarbonElement(_, params) {
        return axios.post("/api/carbon/updatecarbonelement", params, {withCredentials: true});
    },

    deleteCarbonElement(_, params) {
        return axios.post("/api/carbon/deletecarbonelement", params, {withCredentials: true});
    },

    createCarbonFactor(_, params) {
        return axios.post("/api/carbon/createcarbonfactor", params, {withCredentials: true});
    },

    updateCarbonFactor(_, params) {
        return axios.post(`/api/carbon/updatecarbonfactor/${params.carbon_factor_id}`, params, {withCredentials: true});
    },

    deleteCarbonFactor(_, params) {
        return axios.post('/api/carbon/deletecarbonfactor', params, {withCredentials: true});
    },

    createCarbonVehicleFactor(_, params) {
        return axios.post("/api/carbon/createcarbonvehiclesfactor", params, {withCredentials: true});
    },

    updateCarbonVehicleFactor(_, params) {
        return axios.post(`/api/carbon/updatecarbonvehiclesfactor/${params.carbon_vehicle_factor_id}`, params, {withCredentials: true});
    },

    deleteCarbonVehicleFactor(_, params) {
        return axios.post('/api/carbon/deletecarbonvehiclesfactor', params, {withCredentials: true});
    },

    // Countries //

    getCarbonCountries(_) {
        return axios.get("/api/carbon/getcarboncountries");
    },

    createCarbonCountry(_, params) {
        return axios.post("/api/carbon/createcarboncountry", params, { withCredentials: true});
    },

    updateCarbonCountry(_, params) {
        return axios.post(`/api/carbon/updatecarboncountry`, params, { withCredentials: true});
    },

    deleteCarbonCountry(_, params) {
        return axios.post(`/api/carbon/deletecarboncountry`, params, { withCredentials: true});
    },

    // Units //

    getCarbonUnits(_) {
        return axios.get("/api/carbon/getcarbonunits");
    },

    createCarbonUnit(_, params) {
        return axios.post("/api/carbon/createcarbonunit", params, { withCredentials: true});
    },

    updateCarbonUnit(_, params) {
        return axios.post(`/api/carbon/updatecarbonunit`, params, { withCredentials: true});
    },

    deleteCarbonUnit(_, params) {
        return axios.post(`/api/carbon/deletecarbonunit`, params, { withCredentials: true});
    },

    // F.E.'s //

    getCarbonFes(_) {
        return axios.get("/api/carbon/getcarbonfes");
    },

    createCarbonFe(_, params) {
        return axios.post("/api/carbon/createcarbonfe", params, { withCredentials: true});
    },

    updateCarbonFe(_, params) {
        return axios.post(`/api/carbon/updatecarbonfe`, params, { withCredentials: true});
    },

    deleteCarbonFe(_, params) {
        return axios.post(`/api/carbon/deletecarbonfe`, params, { withCredentials: true});
    },

    // Activities //

    getCarbonActivities(_) {
        return axios.get("/api/carbon/getcarbonactivities");
    },

    createCarbonActivity(_, params) {
        return axios.post("/api/carbon/createcarbonactivity", params, { withCredentials: true});
    },

    updateCarbonActivity(_, params) {
        return axios.post(`/api/carbon/updatecarbonactivity`, params, { withCredentials: true});
    },

    deleteCarbonActivity(_, params) {
        return axios.post(`/api/carbon/deletecarbonactivity`, params, { withCredentials: true});
    },

    // Subactivities //

    getCarbonSubactivities(_) {
        return axios.get("/api/carbon/getcarbonsubactivities");
    },

    createCarbonSubactivity(_, params) {
        return axios.post("/api/carbon/createcarbonsubactivity", params, { withCredentials: true});
    },

    updateCarbonSubactivity(_, params) {
        return axios.post(`/api/carbon/updatecarbonsubactivity`, params, { withCredentials: true});
    },

    deleteCarbonSubactivity(_, params) {
        return axios.post(`/api/carbon/deletecarbonsubactivity`, params, { withCredentials: true});
    },

    // Categories //

    getCarbonCategories(_) {
        return axios.get("/api/carbon/getcarboncategories");
    },

    createCarbonCategory(_, params) {
        return axios.post("/api/carbon/createcarboncategory", params, { withCredentials: true});
    },

    updateCarbonCategory(_, params) {
        return axios.post(`/api/carbon/updatecarboncategory`, params, { withCredentials: true});
    },

    deleteCarbonCategory(_, params) {
        return axios.post(`/api/carbon/deletecarboncategory`, params, { withCredentials: true});
    },
}